import React from 'react';
import classNames from 'classnames';
import translate from '@/lib/intl/translate';
import IWaveEvaluationClassNameMap from '../constants/IWaveEvaluationClassNameMap';
import IWaveEvaluationI18nMap from '../constants/IWaveEvaluationI18nMap';
import type IWaveScore from '../constants/IWaveScore';

export default function IWaveScoreEvaluation({
  className,
  score,
  withColor = false,
}: {
  className?: string;
  score: IWaveScore;
  withColor?: boolean;
}) {
  return (
    <span
      className={classNames(className, {
        [IWaveEvaluationClassNameMap[score]]: withColor,
      })}
    >
      {translate(IWaveEvaluationI18nMap[score])}
    </span>
  );
}
